export const Types = {
    SAVE_LIST_AGENCY: 'SAVE_LIST_AGENCY',
    SAVE_LIST_REQUEST_AGENCY: 'SAVE_LIST_REQUEST_AGENCY',
    SAVE_LIST_CONFIG_AGENCY: 'SAVE_LIST_CONFIG_AGENCY',
    SAVE_LIST_ALL_CONFIG_AGENCY: 'SAVE_LIST_ALL_CONFIG_AGENCY',
    SAVE_LIST_AGENCY_REVIEW: 'SAVE_LIST_AGENCY_REVIEW'
}
